import { ExchangeRatesChartDailyData, MarketBrief, MarketHistory, MarketHistoryDailyMap } from 'models/market'
import { PeggedPairConfig } from 'services/wp-api/pegged-currency-pairs-api'

// Market history

export const onlyForexMarketHistory = (source: MarketHistory, pair: string, pegRate: number): MarketHistory => ({
  ...source,
  pair,
  fx_series: scaleFxSeries(source.fx_series, pegRate),
  ik_series: [],
})

export const scaleDailySeries = (series: ExchangeRatesChartDailyData, pegRate: number): ExchangeRatesChartDailyData =>
  series.map(([ts, value]) => [ts, value / pegRate])

export const scaleFxSeries = (series: MarketHistory['fx_series'], pegRate: number): MarketHistory['fx_series'] =>
  series.map(([ts, open, high, low, close]) => [ts, open / pegRate, high / pegRate, low / pegRate, close / pegRate])

export const peggedMarketHistoryDailyMap = (
  data: MarketHistoryDailyMap,
  peggedPairs: Record<string, PeggedPairConfig>,
): MarketHistoryDailyMap => {
  const result = { ...data }

  for (const [pair, { sourcePair, pegRate }] of Object.entries(peggedPairs)) {
    if (result[pair]?.length) continue
    const source = result[sourcePair]
    if (source) result[pair] = scaleDailySeries(source, pegRate)
  }
  return result
}

// Merket brief

export const isForexMarketBrief = (brief?: MarketBrief): boolean => Boolean(brief?.directExchangeOffers?.forexNow)

export const onlyForexMarketBrief = (source: MarketBrief, pair: string, pegRate: number): MarketBrief => ({
  ts: source.ts,
  pair,
  directExchangeOffers: {
    buyNow: 0,
    buyOld: 0,
    sellNow: 0,
    sellOld: 0,
    forexNow: source.directExchangeOffers.forexNow / pegRate,
    forexOld: source.directExchangeOffers.forexOld / pegRate,
  },
})

export const peggedMarketBrief = (
  briefs: MarketBrief[],
  peggedPairs: Record<string, PeggedPairConfig>,
): MarketBrief[] => {
  const result = [...briefs]
  for (const [pair, { sourcePair, pegRate }] of Object.entries(peggedPairs)) {
    if (isForexMarketBrief(briefs.find((brief) => brief.pair === pair))) continue
    const source = briefs.find((brief) => brief.pair === sourcePair)
    if (source) result.push(onlyForexMarketBrief(source, pair, pegRate))
  }
  return result
}
